import { render, staticRenderFns } from "./ChallengeLeaderboard.vue?vue&type=template&id=bdf8f148&scoped=true&"
import script from "./ChallengeLeaderboard.vue?vue&type=script&lang=js&"
export * from "./ChallengeLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeLeaderboard.vue?vue&type=style&index=0&id=bdf8f148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf8f148",
  null
  
)

export default component.exports